'use strict';

/**
 * Created by sguilly on 04/10/16.
 */
(function () {
    'use strict';

    angular.module('common', ['ui.router', 'ui.bootstrap', 'oc.lazyLoad', 'tmh.dynamicLocale', 'ngAnimate', 'mwl.confirm', 'angular-confirm', 'cfp.hotkeys', 'my-formly', 'smart-table', 'xeditable', 'frapontillo.bootstrap-switch', 'ngTagsInput', 'ngFileUpload', 'ngFileSaver', 'gallery', 'ui.mask', 'exceptionOverride']);
})();